import type { CachePersona } from '../store/schema/RecipientCacheStore';
import { searchCacheWithFunction } from './searchCache';

export const getRecipientFromCacheForSmtp = (smtp: string): CachePersona | null => {
    const cachePredicate = (persona: CachePersona) =>
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (9,9): Object is possibly 'undefined'.
        // @ts-expect-error
        persona.EmailAddress.RoutingType === 'SMTP' &&
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (13,9): Object is possibly 'undefined'.
        // @ts-expect-error
        persona.EmailAddress.EmailAddress &&
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (17,9): Object is possibly 'undefined'.
        // @ts-expect-error
        persona.EmailAddress.EmailAddress.toLowerCase() === smtp.toLowerCase();

    const result = searchCacheWithFunction(
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (23,9): Argument of type '(persona: CachePersona) => boolean | "" | undefined' is not assignable to parameter of type '(persona: CachePersona) => boolean'.
        // @ts-expect-error
        cachePredicate,
        1 //numberOfResults
    );

    return result.length ? result[0] : null;
};
